import { extend } from 'lodash'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	data: {},
	form: [],
	user: {},
	filledVars: {},
	created: false,
	createdDocumentId: null,
	createdDocumentData: null,
	authorized: true,
	error: null,
	loading: false,
	downloadingDocument: false,
}

const { actions, reducer } = createSlice({
	name: 'externalContract',
	initialState,
	reducers: {
		verifyToken: (state) =>
			extend(state, {
				loading: true,
			}),
		verifyTokenSuccess: (state, { payload }) =>
			extend(state, {
				data: payload.data,
				form: payload.data.form ? payload.data.form : [],
				authorized: payload.data.Authorized,
				error: null,
				loading: false,
			}),
		verifyTokenFailure: (state, { payload }) =>
			extend(state, {
				error: payload.error,
				authorized: false,
				loading: false,
			}),
		storeURLVariables: (state, { payload }) =>
			extend(state, {
				filledVars: payload.variables,
			}),
		createContractExternal: (state) => state,
		createContractExternalSuccess: (state, { payload }) =>
			extend(state, {
				created: true,
				createdDocumentId: payload.documentId,
				createdDocumentData: payload.documentData,
			}),
		createContractExternalFailure: (state, { payload }) =>
			extend(state, {
				error: payload.error,
			}),
		downloadExternalDocument: (state) =>
			extend(state, {
				downloadingDocument: true,
			}),
		downloadExternalDocumentSuccess: (state) =>
			extend(state, {
				downloadingDocument: false,
			}),
		downloadExternalDocumentFailure: (state, { payload }) =>
			extend(state, {
				downloadingDocument: false,
				error: payload.error,
			}),
	},
})

export const {
	verifyToken,
	verifyTokenSuccess,
	verifyTokenFailure,
	storeURLVariables,
	createContractExternal,
	createContractExternalSuccess,
	createContractExternalFailure,
	downloadExternalDocument,
	downloadExternalDocumentSuccess,
	downloadExternalDocumentFailure,
} = actions

export { default as externalContractSaga } from './sagas'

export default reducer
